import React from 'react'
import { useHistory } from 'react-router-dom'

import HubSpotForm from '../form/HubSpotForm'

const QuotePage = props => {
  return (
    <div style={{ marginBottom: '25px' }}>
      <div className="container">
        <div className="row">
          <h2 className="page-title">Request Demo Access</h2>
        </div>
      </div>
      <div className="title-block-bar" style={{ backgroundColor: '#57ad65' }}>
        <div className="container">
          <p style={{ fontSize: '1.2rem' }}>
            Please fill out the form below, and we'll be happy to get you setup with
            access to the demo site.
          </p>
        </div>
      </div>
      <div style={{ backgroundColor: '#57ad65' }}>
        <div className="container"></div>
      </div>
      <div className="container">
        <HubSpotForm
          formId="50cadde3-8caf-47b3-97f5-beee473cd1ef"
          onSubmit={v => {
            const browserHistory = useHistory()

            browserHistory.push(
              `${
                props.params?.state ? `/${props.params.state}` : ''
              }/demo-access/confirmation`
            )
          }}
        />
      </div>
    </div>
  )
}

export default QuotePage
